module.exports = __webpack_public_path__ + "static/img/age_dist.b71f96b9.png";